type Props = {
  children: React.ReactNode
}

const MediumTitle = ({ children }: Props) => {
  return <h2 className="text-3xl leading-loose font-medium mb-4">{children}</h2>
}

export default MediumTitle
